import React, { useState, useEffect } from 'react';
import { siteConfig } from './config';

const GalleryPage = ({ isDarkMode = false }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const galleryImages = [
    {
      id: 1,
      src: "images/photogallery/JB-Lodge Front view.jpg",
      lightboxSrc: "images/photogallery/JB-Lodge Front view.jpg",
      alt: "J&B Lodge Front view",
      category: "exterior"
    },
    {
      id: 2,
      src: "images/homegallery/JB-Lodge-300x225-1.jpg",
      lightboxSrc: "images/homegallery/JB-Lodge-300x225-1.jpg",
      alt: "J&B Lodge exterior view",
      category: "exterior"
    },
    {
      id: 3,
      src: "images/homegallery/Outside-JB-Lodge-300x225-1.jpg",
      lightboxSrc: "images/homegallery/Outside-JB-Lodge-300x225-1.jpg",
      alt: "Outside view of J&B Lodge",
      category: "exterior"
    },
    {
      id: 4,
      src: "images/homegallery/Inside-JB-Lodge-300x225-1.jpg",
      lightboxSrc: "images/homegallery/Inside-JB-Lodge-300x225-1.jpg",
      alt: "Inside view of J&B Lodge",
      category: "interior"
    },
    {
      id: 5,
      src: "images/homegallery/JnB-Lodge-Living-Room-300x225-1.jpg",
      lightboxSrc: "images/homegallery/JnB-Lodge-Living-Room-300x225-1.jpg",
      alt: "J&B Lodge living room",
      category: "living"
    },
    {
      id: 6,
      src: "images/homegallery/JB-Lodge-Snow-300x225-1.jpg",
      lightboxSrc: "images/homegallery/JB-Lodge-Snow-300x225-1.jpg",
      alt: "J&B Lodge in snow",
      category: "exterior"
    },

    {
      id: 8,
      src: "images/photogallery/JB-Lodge6.jpg",
      lightboxSrc: "images/photogallery/JB-Lodge6.jpg",
      alt: "J&B Lodge view",
      category: "exterior"
    },
    {
      id: 9,
      src: "images/photogallery/JB-Lodge7.jpg",
      lightboxSrc: "images/photogallery/JB-Lodge7.jpg",
      alt: "J&B Lodge view",
      category: "exterior"
    },
    {
      id: 10,
      src: "images/photogallery/JB-Lodge8.jpg",
      lightboxSrc: "images/photogallery/JB-Lodge8.jpg",
      alt: "J&B Lodge view",
      category: "exterior"
    },
    {
      id: 11,
      src: "images/photogallery/JB-Lodge9.jpg",
      lightboxSrc: "images/photogallery/JB-Lodge9.jpg",
      alt: "J&B Lodge view",
      category: "exterior"
    },
    {
      id: 12,
      src: "images/photogallery/JB-Lodge10.jpg",
      lightboxSrc: "images/photogallery/JB-Lodge10.jpg",
      alt: "J&B Lodge view",
      category: "exterior"
    },
    {
      id: 13,
      src: "images/photogallery/JB-Lodge11.jpg",
      lightboxSrc: "images/photogallery/JB-Lodge11.jpg",
      alt: "J&B Lodge view",
      category: "exterior"
    },
    {
      id: 14,
      src: "images/photogallery/JB-Lodge12.jpg",
      lightboxSrc: "images/photogallery/JB-Lodge12.jpg",
      alt: "J&B Lodge view",
      category: "exterior"
    },
    {
      id: 15,
      src: "images/photogallery/JB-Lodge13.jpg",
      lightboxSrc: "images/photogallery/JB-Lodge13.jpg",
      alt: "J&B Lodge view",
      category: "exterior"
    },
    {
      id: 16,
      src: "images/photogallery/JB-Lodge14.jpg",
      lightboxSrc: "images/photogallery/JB-Lodge14.jpg",
      alt: "J&B Lodge view",
      category: "exterior"
    },
    {
      id: 17,
      src: "images/photogallery/JB-Lodge15.jpg",
      lightboxSrc: "images/photogallery/JB-Lodge15.jpg",
      alt: "J&B Lodge view",
      category: "exterior"
    },
    {
      id: 18,
      src: "images/photogallery/JB-Lodge16.jpg",
      lightboxSrc: "images/photogallery/JB-Lodge16.jpg",
      alt: "J&B Lodge view",
      category: "exterior"
    },
    {
      id: 19,
      src: "images/photogallery/2018-01-12-e1516087105655.jpg",
      lightboxSrc: "images/photogallery/2018-01-12-e1516087105655.jpg",
      alt: "J&B Lodge view",
      category: "exterior"
    },
    {
      id: 20,
      src: "images/photogallery/2018-01-12-1-e1516087134366.jpg",
      lightboxSrc: "images/photogallery/2018-01-12-1-e1516087134366.jpg",
      alt: "J&B Lodge view",
      category: "exterior"
    }
  ];

  const openLightbox = (image) => {
    const index = galleryImages.findIndex(img => img.id === image.id);
    setCurrentImageIndex(index);
    setSelectedImage(image);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    setCurrentImageIndex(0);
  };

  const goToNext = () => {
    const nextIndex = (currentImageIndex + 1) % galleryImages.length;
    setCurrentImageIndex(nextIndex);
    setSelectedImage(galleryImages[nextIndex]);
  };

  const goToPrevious = () => {
    const prevIndex = currentImageIndex === 0 ? galleryImages.length - 1 : currentImageIndex - 1;
    setCurrentImageIndex(prevIndex);
    setSelectedImage(galleryImages[prevIndex]);
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImage) return;
      
      switch (e.key) {
        case 'Escape':
          closeLightbox();
          break;
        case 'ArrowRight':
        case ' ':
          e.preventDefault();
          goToNext();
          break;
        case 'ArrowLeft':
          e.preventDefault();
          goToPrevious();
          break;
        default:
          break;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, currentImageIndex, goToNext, goToPrevious, closeLightbox]);

  // Touch/swipe navigation
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      goToNext();
    } else if (isRightSwipe) {
      goToPrevious();
    }

    setTouchStart(null);
    setTouchEnd(null);
  };

  return (
    <div className={`min-h-screen font-sans ${isDarkMode ? 'bg-gray-900' : ''}`} style={!isDarkMode ? { backgroundColor: '#f6f2ec' } : {}}>
      {/* Hero Section */}
      <div className="relative h-[400px] w-full overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')"
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-40"></div>
          <div className="relative h-full flex items-center justify-center">
            <div className="text-center text-white px-4">
              <h1 className="text-5xl md:text-6xl font-bold mb-4 leading-tight">
                Gallery
              </h1>
              <p className="text-xl md:text-2xl font-medium opacity-90">
              Discover the unit and views that awaits you at {siteConfig.siteTitle}.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Gallery Section */}
      <div className="max-w-[80rem] mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image) => (
            <div
              key={image.id}
              className="group relative overflow-hidden rounded-lg shadow-lg cursor-pointer transform transition-transform duration-300 hover:scale-105"
              onClick={() => openLightbox(image)}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center">
                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"></path>
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className={`rounded-lg shadow-lg p-8 max-w-2xl mx-auto ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
            <h3 className={`text-2xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>Ready to experience a fast website yourself?</h3>
            <p className={`mb-6 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
              Contact us today, and we'll get you up and running for only R200pm.
            </p>
            <button 
              onClick={() => window.dispatchEvent(new CustomEvent('openBookingModal'))}
              className="px-8 py-3 bg-gray-800 text-white rounded-full font-medium hover:bg-gray-900 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
            >
              Book Your Stay
            </button>
          </div>
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4"
          onClick={closeLightbox}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div className="relative max-w-4xl max-h-full">
            {/* Close button */}
            <button
              onClick={closeLightbox}
                              className="absolute top-4 right-4 z-10 bg-white rounded-full p-2 shadow-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                style={{ backgroundColor: '#f6f2ec' }}
              aria-label="Close lightbox"
            >
              <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>

            {/* Previous button */}
            <button
              onClick={(e) => { e.stopPropagation(); goToPrevious(); }}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 z-10 bg-black bg-opacity-30 rounded-full p-3 shadow-lg hover:bg-opacity-50 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
              aria-label="Previous image"
            >
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path>
              </svg>
            </button>

            {/* Next button */}
            <button
              onClick={(e) => { e.stopPropagation(); goToNext(); }}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 z-10 bg-black bg-opacity-30 rounded-full p-3 shadow-lg hover:bg-opacity-50 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
              aria-label="Next image"
            >
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </button>

            {/* Image */}
            <img
              src={selectedImage.lightboxSrc || selectedImage.src}
              alt={selectedImage.alt}
              className="max-w-full max-h-full object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />

            {/* Image info */}
            <div className="absolute bottom-4 left-4 text-white bg-black bg-opacity-50 px-4 py-2 rounded-lg">
              <p className="text-sm">{selectedImage.alt}</p>
              <p className="text-xs opacity-75">{currentImageIndex + 1} of {galleryImages.length}</p>
            </div>

            {/* Navigation dots */}
            <div className="absolute bottom-4 right-4 flex space-x-2">
              {galleryImages.map((_, index) => (
                <button
                  key={index}
                  onClick={(e) => { 
                    e.stopPropagation(); 
                    setCurrentImageIndex(index);
                    setSelectedImage(galleryImages[index]);
                  }}
                  className={`w-2 h-2 rounded-full transition-all duration-200 ${
                    index === currentImageIndex 
                      ? 'bg-white' 
                      : 'bg-white bg-opacity-50 hover:bg-opacity-75'
                  }`}
                  aria-label={`Go to image ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryPage; 